import React, { useEffect, useState, useMemo } from "react";
import { useDemo } from "@/context/DemoContext";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/helpers";
import { Link } from "react-router-dom";
import FeedbackButton from "@/components/FeedbackButton";

function startOfWeek(d) {
  const dt = new Date(d);
  const day = (dt.getDay() + 6) % 7;
  dt.setDate(dt.getDate() - day);
  dt.setHours(0,0,0,0);
  return dt;
}

export default function CalendarioPage() {
  const { data } = useDemo();
  const [interventi, setInterventi] = useState([]);
  const [tecFilter, setTecFilter] = useState("all");
  const [sedeFilter, setSedeFilter] = useState("all");
  const [weekStart, setWeekStart] = useState(startOfWeek(new Date()));

  useEffect(() => { api.get("/interventi").then(setInterventi); }, []);

  const days = Array.from({length:7}).map((_,i) => {
    const d = new Date(weekStart); d.setDate(d.getDate()+i); return d;
  });

  const filtered = useMemo(() => interventi.filter(i => {
    if (tecFilter !== "all" && !(i.tecnici_ids||[]).includes(tecFilter)) return false;
    if (sedeFilter !== "all") {
      const t = data.tickets.find(t => t.id === i.ticket_id);
      if (t?.sede !== sedeFilter) return false;
    }
    return true;
  }), [interventi, tecFilter, sedeFilter, data.tickets]);

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <h1 className="text-2xl font-bold">Calendario settimanale</h1>
        <FeedbackButton schermata="Calendario" />
      </div>
      <Card className="emmepi-card p-3 mb-3 flex flex-wrap gap-2 items-center">
        <button onClick={() => { const d = new Date(weekStart); d.setDate(d.getDate()-7); setWeekStart(d); }} className="px-3 py-1.5 border rounded hover:bg-slate-50">← Precedente</button>
        <button onClick={() => setWeekStart(startOfWeek(new Date()))} className="px-3 py-1.5 border rounded hover:bg-slate-50">Oggi</button>
        <button onClick={() => { const d = new Date(weekStart); d.setDate(d.getDate()+7); setWeekStart(d); }} className="px-3 py-1.5 border rounded hover:bg-slate-50">Successiva →</button>
        <div className="ml-2 text-sm text-slate-600">Settimana dal {fmtDate(weekStart)} al {fmtDate(days[6])}</div>
        <div className="ml-auto flex gap-2">
          <Select value={tecFilter} onValueChange={setTecFilter}>
            <SelectTrigger className="w-[220px]" data-testid="cal-tec-filter"><SelectValue placeholder="Tecnico" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tutti i tecnici</SelectItem>
              {data.tecnici.map(t => <SelectItem key={t.id} value={t.id}>{t.nome}</SelectItem>)}
            </SelectContent>
          </Select>
          <Select value={sedeFilter} onValueChange={setSedeFilter}>
            <SelectTrigger className="w-[130px]"><SelectValue placeholder="Sede" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tutte</SelectItem>
              <SelectItem value="Perugia">Perugia</SelectItem>
              <SelectItem value="Treviso">Treviso</SelectItem>
              <SelectItem value="Milano">Milano</SelectItem>
              <SelectItem value="Novara">Novara</SelectItem>
              <SelectItem value="Pieri">Pieri</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </Card>
      <div className="grid grid-cols-7 gap-2">
        {days.map((d, i) => {
          const ymd = d.toISOString().slice(0,10);
          const dayInts = filtered.filter(x => x.data_pianificata === ymd);
          return (
            <Card key={i} className="emmepi-card p-2 min-h-[220px]">
              <div className="text-xs font-semibold text-slate-700 uppercase mb-1">
                {["Lun","Mar","Mer","Gio","Ven","Sab","Dom"][i]} {d.getDate()}/{d.getMonth()+1}
              </div>
              <div className="space-y-1.5">
                {dayInts.map(iv => {
                  const t = data.tickets.find(t => t.id === iv.ticket_id);
                  const cli = data.clienti.find(c => c.id === t?.cliente_id);
                  return (
                    <Link key={iv.id} to={`/ticket/${iv.ticket_id}`} className="block bg-blue-50 border border-blue-200 rounded p-1.5 hover:bg-blue-100" data-testid={`cal-int-${iv.id}`}>
                      <div className="text-xs font-mono font-semibold text-blue-800">{t?.numero}</div>
                      <div className="text-xs text-slate-800 truncate">{cli?.ragione_sociale}</div>
                      <div className="text-[10px] text-slate-500 truncate">{(iv.tecnici_ids||[]).map(tid => data.tecnici.find(x=>x.id===tid)?.nome).filter(Boolean).join(", ")}</div>
                    </Link>
                  );
                })}
              </div>
            </Card>
          );
        })}
      </div>
      <div className="text-xs text-slate-500 mt-3">Nessuna sincronizzazione Outlook. Le date pianificate sono separate dalle giornate rendicontate nei rapporti.</div>
    </div>
  );
}
